import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    Typography,
    IconButton,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const allowedAttachmentTypes = [
    { mime: "application/pdf", label: "PDF" },
    { mime: "image/jpeg", label: "JPEG" },
    { mime: "image/jpg", label: "JPG" },
    { mime: "image/png", label: "PNG" },
    { mime: "image/svg+xml", label: "SVG" },
    { mime: "application/vnd.ms-excel", label: "Excel (XLS)" },
    { mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", label: "Excel (XLSX)" },
    { mime: "application/vnd.ms-excel.sheet.macroEnabled.12", label: "Excel (XLSM)" },
    { mime: "application/vnd.ms-excel.sheet.binary.macroEnabled.12", label: "Excel (XLSB)" },
    { mime: "text/csv", label: "CSV" },
    { mime: "application/zip", label: "ZIP" },
    { mime: "application/x-rar-compressed", label: "RAR" },
];

export default function AllowedFormatsInfo() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <IconButton onClick={() => setOpen(true)} color="info">
                <InfoIcon />
            </IconButton>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>დაიშვება მხოლოდ შემდეგი ფორმატები</DialogTitle>
                <DialogContent>

                    <List dense>
                        {allowedAttachmentTypes.map((type) => (
                            <ListItem key={type.mime}>
                                <Typography variant="body2">.{type.label}</Typography>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>
        </>
    );
}
